enum ADVANCE_STATUS {
  DRAFT = "Draft",
  REQUESTED = "Requested",
  RELEASE_PENDING = "Release Pending",
  RELEASE_PARTIAL = "Release Partial",
  RELEASE_COMPLETE = "Release Complete",
  REJECTED = "Rejected",
}

export default ADVANCE_STATUS
